import { useGetAssesmentCourses, useGetLmsSubject } from "../../../assets/nodeApi/getApi/getAdminApi";

export const useAssesmentDropdownOptions = () => {
  

    const { data: courseList, isLoading: isCourseLoading } = useGetAssesmentCourses()




    const courseOptions =
      courseList?.data?.map((item, index) => ({
            id: item.id,
            label: item.title,
            value: item.title,
            sr_no: index + 1,
            ...item
        })) ?? [];


    const assesmentSubjectType = [
        {
            id: 1,
            label: "LANGUAGE",
            value: "LANGUAGE",
        },
        {
            id: 2,
            label: "SUBJECT",
            value: "SUBJECT",
        },
    ];



    return {
        assesmentSubjectType: {
            options: assesmentSubjectType,
        },
      
          coursesForAssessment: {
            options:   courseOptions ,
            isLoading:isCourseLoading
        }

      

    };
};
